import { clone } from "@/util/libUtil.js"

import defaultAgendadoForm from "./defaultAgendadoForm";
import defaultAtencionForm from "./defaultAtencionForm";

let defaultAtencionAgendadoForm = clone(defaultAtencionForm)
defaultAtencionAgendadoForm.agendado = clone(defaultAgendadoForm)

export default defaultAtencionAgendadoForm